import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=2f675888&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"
import style0 from "./page-header.vue?vue&type=style&index=0&id=2f675888&prod&lang=less&scoped=true"
import style1 from "./page-header.vue?vue&type=style&index=1&id=2f675888&prod&lang=less"
import style2 from "./page-header.vue?vue&type=style&index=2&id=2f675888&prod&scoped=true&lang=less"
import style3 from "@/assets/h5css/zujian/pageHeader.less?vue&type=style&index=3&id=2f675888&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f675888",
  null
  
)

export default component.exports